import amplitudeEventNames from '@/consts/analytics/analyticsEventNames';
import analyticsEventProperties from '@/consts/analytics/analyticsEventProperties';

import amplitude from './amplitude';

const trackAutoDeliveryDcxBannerClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.AUTODELIVERY_BANNER_CLICKED);
};

const trackAutoDeliveryDcxDashboardButtonClick = (trackingValue) => {
    if (!trackingValue) return;

    amplitude.trackWithSource(amplitudeEventNames.AUTODELIVERY_DASHBOARD_BUTTON_CLICKED, {
        [analyticsEventProperties.TRACKING_VALUE]: trackingValue,
    });
};

const trackAutoDeliveryDcxGetStartedScreen = () => {
    amplitude.trackWithSource(amplitudeEventNames.AUTODELIVERY_GET_STARTED_SCREEN_VIEWED);
};

const trackAutoDeliveryDcxGetStartedButtonClick = () => {
    amplitude.trackWithSource(amplitudeEventNames.AUTODELIVERY_GET_STARTED_BUTTON_CLICKED);
};

const trackAutoDeliveryDcxOrderScreen = (autoDeliveryStatus, orderSummary = null) => {
    amplitude.trackWithSource(amplitudeEventNames.ORDER_SCREEN_VIEWED, {
        [analyticsEventProperties.AUTODELIVERY_STATUS]: autoDeliveryStatus,
        ...getOrderSummaryProperties(orderSummary),
    });
};

const trackAutoDeliveryDcxOrderSummaryLinkClick = (autoDeliveryStatus) => {
    amplitude.trackWithSource(amplitudeEventNames.ORDER_SUMMARY_LINK_CLICKED, {
        [analyticsEventProperties.AUTODELIVERY_STATUS]: autoDeliveryStatus,
    });
};

const trackAutoDeliveryDcxDeliverAsapStarted = (orderSummary) => {
    amplitude.trackWithSource(amplitudeEventNames.DELIVER_ASAP_STARTED, {
        ...getOrderSummaryProperties(orderSummary),
    });
};

const trackAutoDeliveryDcxDeliverAsapCompleted = ({success, message, orderSummary}) => {
    amplitude.trackWithSource(amplitudeEventNames.DELIVER_ASAP_COMPLETED, {
        [analyticsEventProperties.SUCCESS]: success,
        [analyticsEventProperties.MESSAGE]: message,
        ...getOrderSummaryProperties(orderSummary),
    });
};

const trackAutoDeliveryDcxOrderButtonClick = (trackingValue, autoDeliveryStatus) => {
    if (!trackingValue) return;

    amplitude.trackWithSource(amplitudeEventNames.ORDER_BUTTON_CLICKED, {
        [analyticsEventProperties.TRACKING_VALUE]: trackingValue,
        [analyticsEventProperties.AUTODELIVERY_STATUS]: autoDeliveryStatus,
    });
};

const trackAutoDeliveryDcxSkipDeliveryNotAvailable = (orderSummary) => {
    amplitude.trackWithSource(amplitudeEventNames.SKIP_DELIVER_NOT_AVAILABLE, {
        ...getOrderSummaryProperties(orderSummary),
    });
};

const trackAutoDeliveryDcxSkipDeliveryStarted = (orderSummary) => {
    amplitude.trackWithSource(amplitudeEventNames.SKIP_DELIVERY_STARTED, {
        ...getOrderSummaryProperties(orderSummary),
    });
};

const trackAutoDeliveryDcxSkipDeliveryCompleted = ({success, message, orderSummary}) => {
    amplitude.trackWithSource(amplitudeEventNames.SKIP_DELIVERY_COMPLETED, {
        [analyticsEventProperties.SUCCESS]: success,
        [analyticsEventProperties.MESSAGE]: message,
        ...getOrderSummaryProperties(orderSummary),
    });
};

const getOrderSummaryProperties = (orderSummary) => {
    return orderSummary ? {[analyticsEventProperties.ORDER_SUMMARY]: orderSummary} : {};
};

export default {
    trackAutoDeliveryDcxBannerClick,
    trackAutoDeliveryDcxDashboardButtonClick,
    trackAutoDeliveryDcxGetStartedScreen,
    trackAutoDeliveryDcxGetStartedButtonClick,
    trackAutoDeliveryDcxOrderScreen,
    trackAutoDeliveryDcxOrderSummaryLinkClick,
    trackAutoDeliveryDcxDeliverAsapStarted,
    trackAutoDeliveryDcxDeliverAsapCompleted,
    trackAutoDeliveryDcxOrderButtonClick,
    trackAutoDeliveryDcxSkipDeliveryNotAvailable,
    trackAutoDeliveryDcxSkipDeliveryStarted,
    trackAutoDeliveryDcxSkipDeliveryCompleted,
};
